import { render } from "./catalog.cattle.io.app.vue?vue&type=template&id=6487da97&scoped=true"
import script from "./catalog.cattle.io.app.vue?vue&type=script&lang=js"
export * from "./catalog.cattle.io.app.vue?vue&type=script&lang=js"

import "./catalog.cattle.io.app.vue?vue&type=style&index=0&id=6487da97&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6487da97"]])

export default __exports__